import { render, staticRenderFns } from "./kioskList.vue?vue&type=template&id=7488464b"
import script from "./kioskList.vue?vue&type=script&lang=js"
export * from "./kioskList.vue?vue&type=script&lang=js"
import style0 from "./kioskList.vue?vue&type=style&index=0&id=7488464b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports